import { LEVEL_THEMES, PLACEMENT_TYPE_HERO_SPAWN } from "./consts";

export const getNewLevel = () => {
  return {
    title: "Custom Level",
    theme: LEVEL_THEMES.BLUE,
    tilesWidth: 7,
    tilesHeight: 7,
    isEditableByUser: true,
    placements: [
      {
        type: PLACEMENT_TYPE_HERO_SPAWN,
        x: 3,
        y: 3,
      },
      {
        x: 6,
        y: 6,
        type: "PLACEMENT_TYPE_GOAL",
      },
    ],
  };
};
